import React from "react";
import "./Ssparttwo.css";
import partImg from "../../../Gallery/ServicesImages/material/img2.jpg"; // keep your image path same

function Ssparttwo() {
  return (
    <div className="ss2_wrapper">

      {/* HERO SECTION */}
      <section className="ss2_hero">
        <div className="ss2_container">

          <div className="ss2_image">
            <img src={partImg} alt="SS316L Conformal Cooling Part" />
          </div>

          <div className="ss2_content">
            <h1>SS316L Conformal Cooling Components</h1>
            <div className="ss2_line"></div>

            <p>
              Precision-built SS316L components featuring internal conformal
              cooling channels of 1.5 mm diameter, engineered for optimized
              thermal management.
            </p>

            <p>
              Advanced additive manufacturing enables complex internal
              geometries that are not possible with traditional machining,
              delivering improved cooling efficiency and performance stability.
            </p>
          </div>

        </div>
      </section>


    </div>
  );
}

export default Ssparttwo;
